export const navbarMenuTitles = Object.freeze({
    Dashboard: 'Dashboard',
    Opportunities: 'Opportunities',
    BecomeAPartner: "Become a Partner",
    ReferAndEarn: "Refer & Earn",
    BondDirectory: "Bond Directory",
    knowledgeCentre: "Knowledge Centre"
});